import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Category from '@mui/icons-material/Category';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getcommodity } from '../redux/commodity';
import { getpurchase } from '../redux/purchase';
import Progress from '../components/Loader';

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [unit, setUnit] = React.useState('none');
  const [warehouse, setWarehouse] = React.useState('none');
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();
  const warehouses = useSelector((state) => state.warehouse || []);

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    setUnit('none');
    setWarehouse('none');
    document.getElementById('amount').value = '';
    document.getElementById('qty').value = '';
    document.getElementById('community').value = '';
    document.getElementById('date').value = '';
    document.getElementById('others').value = '';
  };

  const addPurchase = async () => {
    setLoading(true);
    const givenBalance = props.chosen.balance;
    const quantity = props.chosen.qty;
    const qtyPurchased = document.getElementById('qty').value;
    const amount = document.getElementById('amount').value;
    const balance = parseFloat(givenBalance) - parseFloat(amount);
    const balanceQty = parseFloat(quantity) - parseFloat(qtyPurchased);

    try {
      const res = await axios.post('https://server.agrotraciserp.com/api/purchase/addpurchase/', {
        batch: props.chosen.batch,
        agent: props.chosen.agent,
        balance: balance,
        qtybalance: balanceQty,
        receivingwarehouse: warehouse,
        product: props.chosen.product,
        amount: document.getElementById('amount').value,
        qty: document.getElementById('qty').value,
        unit: unit,
        community: document.getElementById('community').value,
        date: document.getElementById('date').value,
        others: document.getElementById('others').value,
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getcommodity({ data: res.data.commodity }));
        dispatch(getpurchase({ data: res.data.purchase }));
        setSnackbarMessage('Purchase added successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to add purchase.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error adding purchase.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Update Commodity Aggregation
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="amount"
              label="Amount Purchased"
              type="number"
              autoComplete="current-text"
            />
            <TextField
              id="qty"
              label="Quantity Purchased"
              type="number"
              autoComplete="current-text"
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Unit"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              <option value="tons">tons</option>
              <option value="bags">bags</option>
              <option value="kg">kg</option>
            </TextField>
            <TextField
              id="community"
              label="Community"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="date"
              label="Date Purchased"
              type="date"
              autoComplete="current-text"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              id="outlined-select-currency-native"
              select
              label="Receiving Warehouse"
              value={warehouse}
              onChange={(e) => setWarehouse(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="none">Choose</option>
              {warehouses.map((list) => (
                <option key={list.warehousename} value={list.warehousename}>
                  {list.warehousename}
                </option>
              ))}
            </TextField>
            <TextField
              id="others"
              label="Other Information"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button variant="outlined" startIcon={<Category />} size="large" onClick={addPurchase}>
                Submit
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}